import { useParams, useLocation, Link } from "react-router-dom";
import "../styles/components/OrderSuccess.scss";

function OrderSuccess() {
  const { orderId } = useParams();
  const location = useLocation();
  const confirmation = location.state || null;

  const displayNumber = confirmation?.orderNumber || `#${orderId}`;
  const isPickup = confirmation?.orderType === "pickup";

  return (
    <div className="order-success">
      <div className="success-card">

        <div className="success-icon">
          ✓
        </div>

        <h1>Order Confirmed</h1>

        <p className="order-number">
          Order Number: <span>{displayNumber}</span>
        </p>

        <p className="success-message">
          Thank you for your purchase.
          Our team will contact you shortly to confirm the details.
        </p>

        {confirmation && (
          <div className="order-recap">
            <div className="recap-fulfillment">
              {isPickup ? "Pickup" : "Delivery"}
            </div>

            <div className="recap-items">
              {confirmation.items.map((item, index) => (
                <div key={`${item.id}-${index}`} className="recap-row">
                  <span className="recap-name">
                    {item.name}
                    {item.colorName && ` (${item.colorName})`}{" "}
                    <span className="recap-qty">x {item.qty}</span>
                  </span>
                  <span className="recap-price">
                    ${(Number(item.price) * Number(item.qty)).toFixed(2)}
                  </span>
                </div>
              ))}
            </div>

            <div className="recap-total">
              <span>Total</span>
              <span>${Number(confirmation.totalPrice).toFixed(2)}</span>
            </div>
          </div>
        )}

        <div className="success-actions">
          <Link to="/" className="btn primary">
            Back to Home
          </Link>

          <Link to="/categories" className="btn ghost">
            Continue Shopping
          </Link>
        </div>

      </div>
    </div>
  );
}

export default OrderSuccess;